module.exports = __webpack_public_path__ + "images/play@3x.png?61a61d7f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play@3x.png
// module id = 676
// module chunks = 7